import { Typography, Grid, Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import { getAllUnconfirmedInvoices, confirmInvoice, rejectInvoice, editInvoice } from "../../../util/invoiceHelper"
import ErrorPopUp from "../../../components/Pop_ups/ErrorPopUp";
import LoadingPopUp from "../../../components/Pop_ups/LoadingPopUp";
import PropTypes from "prop-types";
import SuccessSnackBar from "../../../components/SuccessSnackBar";
import InvoiceConfirmDisplay from "./InvoiceConfirmDisplay";
import ChooseOptionPopUp from "../../../components/Pop_ups/ChooseOptionPopUp";

/**
 * Page responsible for displaying timesheets on the admin end
 * @component
 * @category Pages
 * @subcategory Admin 
 */
function InvoiceConfirm(props) {
  const [unconfirmedInvoices, setUnconfirmedInvoices] = useState([]);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("")
  const [showConfirmInvoicesPopUp, setShowConfirmInvoicesPopUp] = useState(false)

  const getInvoices = () => {
    getAllUnconfirmedInvoices((response) => {
      if (response) {
        setUnconfirmedInvoices(response.invoices)
        setHasLoaded(true);
      } else {
        setError(true);
      }
    });
  };

  useEffect(() => {
    setLoading(true)
    getInvoices()
    setLoading(false)
  }, [])

  const selectConfirmation = function (choice)
  {
    if (choice.string === "Yes")
    {
      const invoices = unconfirmedInvoices
      invoices.forEach(function(invoice)
      {
        confirmInvoice(invoice.id, (response) => {
          if (!response)
            setError(true)
        })
      })

      setUnconfirmedInvoices([])
      
    }
    setShowConfirmInvoicesPopUp(false)
  }

  const handleConfirm = function (id)
  {
    setLoading(true)
    confirmInvoice(id, (response) => {
      if (response)
      {
        let invoices_copy = unconfirmedInvoices
        invoices_copy = invoices_copy.filter(invoice => invoice.id !== id)
        setUnconfirmedInvoices(invoices_copy)
      }
      else
        setError(true);
      setLoading(false)
    });
  }

  const handleReject = function (id)
  {
    setLoading(true)
    rejectInvoice(id, (response) => {
      if (response)
      {
        let invoices_copy = unconfirmedInvoices
        invoices_copy = invoices_copy.filter(invoice => invoice.id !== id)
        setUnconfirmedInvoices(invoices_copy)
      }
      else
        setError(true);
      setLoading(false)
    });
  }

  const handleEdit = function (invoice)
  {
    setLoading(true)
    editInvoice(invoice, (response) => {
      if (response)
      {
        const invoice_ind = unconfirmedInvoices.findIndex((invoice_arr) => invoice_arr.id === invoice.id)
        let invoices_copy = unconfirmedInvoices
        invoices_copy[invoice_ind] = invoice
        setUnconfirmedInvoices(invoices_copy)
      }
      else
        setError(true);
      setLoading(false)
    });
  }
  
  return (
    <>
      <Grid
        container
        sx={{ padding: "0.5%", justifyContent: "center", alignItems: "center" }}
      >
        <LoadingPopUp open={loading || !hasLoaded} />
        <ChooseOptionPopUp
          open = {showConfirmInvoicesPopUp}
          onSelect = {selectConfirmation}
          option1 = {{string: "Yes"}}
          option2 = {{string: "No"}}
          title = {"Confirm Your Choice"}
          body = {"Are you sure you'd like to confirm all unconfirmed invoices?"}
        />
        <ErrorPopUp
          open={error}
          onClose={(event) => {
            event.preventDefault();
            setError(false);
          }}
        />
        <Grid item xs={12}>
          <Typography variant="h4" align="center" style={{ marginBottom: "20px" }}>
            Pending Invoices
          </Typography>
        </Grid>

        <Grid item container xs={12}>
          {unconfirmedInvoices.length > 0 ? (
            <>
              <Button variant="h4" align="center" onClick = {() => {setShowConfirmInvoicesPopUp(true)}}
              style={{"font-size": "20px", padding: "10px 20px", margin: "auto", marginBottom: "20px" }}>
                Confirm All Invoices
              </Button>
              <InvoiceConfirmDisplay
                invoices = {unconfirmedInvoices}
                onSuccess={setSuccess}
                hasLoaded={hasLoaded}
                setHasLoaded={setHasLoaded}
                handleConfirm = {handleConfirm}
                handleReject = {handleReject}
                handleEdit = {handleEdit}
              />
              <SuccessSnackBar
                open={Boolean(success)}
                onClose={(event) => {
                  event.preventDefault();
                  setSuccess("");
                }}
                successmessage={success}
              />
            </>
          ) : (
            <Grid item xs={12}>
            <Typography variant="h4" align="center">
              No invoices found
            </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
}


InvoiceConfirm.propTypes = {
  /**
   * profile of currently logged in resource (object following db schema for resource)
   */
  profile: PropTypes.object.isRequired,
};

export default InvoiceConfirm;
